import React from 'react';
import './NeatScheduleMark.css';

const PUBLIC_URL = process.env.PUBLIC_URL || '';

const MARK_SOURCES = {
  full: `${PUBLIC_URL}/neatschedule.png?v=4`,
  header: `${PUBLIC_URL}/brand/neatschedule-header.png`,
  dark: `${PUBLIC_URL}/neatscheduledarkmode.png`,
};

export default function NeatScheduleMark({
  variant = 'light',
  className = '',
  mark = 'full',
  width,
  height,
}) {
  const src = mark === 'header'
    ? MARK_SOURCES.header
    : variant === 'dark'
      ? MARK_SOURCES.dark
      : MARK_SOURCES.full;

  return (
    <img
      className={`neatScheduleMark neatScheduleMark--${variant} ${mark === 'header' ? 'neatScheduleMark--header' : ''} ${className}`.trim()}
      src={src}
      alt="Neat Schedule"
      width={width}
      height={height}
    />
  );
}
